import NotificationPart from "localization/base/pages/rdevNotifications/NotificationPart";

const notificationMessage: NotificationPart = {
  internetOutage: `Internet outage in time from '{from}' to '{to}'.`,
  osVersionChanged: `Operation system version changed from '{oldVersion}' to '{newVersion}'.`,
  rdevVersionChanged: `RDev version changed from '{oldVersion}' to '{newVersion}'.`
};

export default notificationMessage;
